import React, { Component } from "react";
import ReactDOM from "react-dom";
import BootstrapTable from "react-bootstrap-table-next";
// import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import "./styles.css";
import { Button } from "react-bootstrap";


const products = [
  { id: 1, PropertyType:"Commercial", TotalProperties: "200"},
  { id: 2, PropertyType:"Residential", TotalProperties: "200"},
  { id: 3, PropertyType:"Industrial", TotalProperties: "200"},
  // { id: 4, PropertyType:"Commercial", Cost: "200", tax: 82 }
];

class PropertyTypeTable extends Component {
  constructor() {
    super();
    this.state = {
      // For displaying data
      columns: [
        {
          dataField: "id",
          text: "Serial Number",
          sort: true
        },
        {
          dataField: "PropertyType",
          text: "Property Type",
          sort: true
        },
        {
          dataField: "TotalProperties",
          text: "Total Properties"
        }
      ]
    };

 
  }


  render() {
    return (
        <>
       
        <BootstrapTable
        insertRow
        deleteRow={true}
        responsive={true}
          keyField="id"
          striped={true}
          className="text-center"
          data={products}
          columns={this.state.columns}
        />
      
      </>
    );
  }
}


export default PropertyTypeTable;